<template>
    <div>
        <v-row class="no-frame">
            <v-col class="no-frame mr-2">
                <f-date-picker
                    :label            = "label"
                    :time             = "false"
                    v-model           = "data.beginDate"
                    :rules            = "[ fromRule, ]"
                    :error-messages   = "error.begin"
                    :background-color = "background"
                    @change           = "onStartChanged"
                />
            </v-col>
            <v-col class="no-frame ml-2">
                <f-date-picker
                    :label            = "label2"
                    :time             = "false"
                    v-model           = "data.endDate"
                    :rules            = "[toRule]"
                    :error-messages   = "error.end"
                    :background-color = "background"
                    @change           = "onEndChanged"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import FDatePicker from "@/modules/core/components/utils/FDatePicker";
import Core from "@/modules/core/service/Core";
import moment from "moment";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "IncProcessingInterval",

    components: {
        FDatePicker
    },

    props: {
        data: {
            required: true,
            type    : Object
        },
        status: {

        },

        background: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        },

        label: {
            required: false,
            type    : String,
            default : function () {
                return "inc.edit.common.processing.start";
            }
        },
        label2: {
            required: false,
            type    : String,
            default : function () {
                return "inc.edit.common.processing.end";
            }
        },
    },

    data: () => ({
        error  : {
            begin: null,
            end  : null
        }
    }),

    methods: {
        fromRule (value) {
            if (Inc.step.canceled(this.status)) {
                this.error.end   = [];
                this.error.begin = [];
                return true;
            }

            if (!value || value.length === 0) {
                this.error.begin = [this.$t("rules.required")];
                this.error.end = [];
                return false;
            }

            return this.intervallRule(Core.format.date.toJson(value), this.data.endDate);
        },

        toRule (value) {
            if (Inc.step.canceled(this.status)) {
                this.error.end   = [];
                this.error.begin = [];
                return true;
            }

            if (!value || value.length === 0) {
                if (this.status.type === 'T') {
                    this.error.end = [this.$t("rules.required")];
                    this.error.begin = [];
                    return false;
                }

                this.error.end   = [];
                this.error.begin = [];

                return true;
            }

            return this.intervallRule(this.data.beginDate, Core.format.date.toJson(value));
        },

        intervallRule(beginDate, endDate) {
            if (Inc.step.canceled(this.status)) {
                this.error.end   = [];
                this.error.begin = [];
                return true;
            }

            if (moment(beginDate).isAfter (endDate) ) {
                this.error.end   = [this.$t("inc.edit.common.processing.error")];
                this.error.begin = [""];
                return false;
            } else {
                this.error.end   = [];
                this.error.begin = [];
            }

            return true;
        },

        onStartChanged () {
            this.$emit("start-changed", this.data.beginDate)
        },

        onEndChanged () {
            this.$emit("end-changed", this.data.endDate)
        }
    }
}
</script>

<style scoped>

</style>